<template>
  <el-container>
    <el-header>
      <Header @toggle-sidebar="sidebarOpen = !sidebarOpen" />
    </el-header>
    <el-container>
      <div class="aside-mask" v-show="sidebarOpen" @click="sidebarOpen = false"></div>
      <el-aside class="aside-container" :class="{ 'is-open': sidebarOpen }" width="200px">
        <el-menu class="sidebar-menu" :default-active="activeMenu">
          <sidebar-item
            v-for="route in sideRoutes"
            :key="route.path"
            :item="route"
            :base-path="route.path"
          ></sidebar-item>
        </el-menu>
      </el-aside>
      <el-main class="main-container">
        <breadcrumb v-show="this.$route.meta.level !== 0"></breadcrumb>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from './components/Header.vue'
import SidebarItem from './components/SidebarItem.vue'
import { asyncRoutes } from '@/router'
import Breadcrumb from '@/components/Breadcrumb.vue'
import { cloneDeep } from 'lodash'

export default {
  components: {
    Header,
    SidebarItem,
    Breadcrumb,
  },
  data() {
    return {
      sideRoutes: [],
      // 仅窄屏（<=768px）有意义：宽屏下侧边栏常驻，遮罩和位移都不生效
      sidebarOpen: false,
    }
  },
  watch: {
    // 移动端跳转后收起抽屉，否则会盖住刚打开的页面
    $route() {
      this.sidebarOpen = false
    },
    // 抽屉打开时锁住 body 滚动，避免在遮罩上滑动把底层页面带着滚
    sidebarOpen(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    },
  },
  beforeDestroy() {
    // 抽屉开着时组件被销毁，不清理会让 body 永久无法滚动
    document.body.style.overflow = ''
  },
  computed: {
    activeMenu() {
      const { meta, path } = this.$route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
  },
  created() {
    const filterRoutes = (routes) => {
      return routes.reduce((arr, curr) => {
        if (!curr.hidden) {
          if (curr.children) {
            curr.children = filterRoutes(curr.children)
          }
          arr.push(curr)
        }
        return arr
      }, [])
    }
    this.sideRoutes = filterRoutes(cloneDeep(asyncRoutes))
  },
  methods: {
    handleClickMenu(e) {
      this.$router.push(e.key)
    },
    resolvePath(basePath, routePath) {
      return basePath + '/' + routePath
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '~@/styles/variables.less';

.aside-container {
  position: fixed;
  top: @header-height;
  bottom: 0;
  box-shadow: 1px 0 4px rgba(0, 21, 41, 0.08);
}
.sidebar-menu {
  text-align: left;
  border-right: none;
}

// 宽屏下即使 sidebarOpen 为 true 也不该出现
.aside-mask {
  display: none;
}

.el-header {
  position: fixed;
  left: 0;
  right: 0;
  background: #5c76cc;
  height: @header-height !important;
  padding: 0 20px;
  z-index: 10000;
}

// 窄屏下侧边栏改为抽屉：默认移出视口，点 Header 的按钮滑入，带遮罩
// z-index 依据：页面内容最高 101（perDetails/index.vue），Element 弹层 2000 起，
// .el-header 为 10000。1000/1001 高于内容、低于弹层与 Header。
// 遮罩从 @header-height 开始，不盖住 Header，保证汉堡按钮始终可点。
@media (max-width: 768px) {
  .aside-mask {
    display: block;
    position: fixed;
    top: @header-height;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1000;
  }
  .aside-container {
    // 原本靠 fixed 的静态位置贴左，这里显式声明
    left: 0;
    z-index: 1001;
    transform: translateX(-100%);
    transition: transform 0.28s ease;

    &.is-open {
      transform: translateX(0);
    }
  }
  .main-container {
    margin-left: 0;
  }
}
</style>
